(() => {
  const config = document.querySelector('[data-fp-member-saved]');
  if (!config) return;
  const ms = document.documentElement.lang.startsWith('ms');
  const text = (en, my) => ms ? my : en;
  const dialog = () => document.querySelector('[data-fp-saved-dialog]');
  const list = () => document.querySelector('[data-fp-saved-list]');
  let client, pageRequest;
  const localUrl = value => window.FivePointI18n.localUrl(value);
  function feedback(error, retry) {
    const root = list(); if (!root) return;
    root.replaceChildren(); root.removeAttribute('aria-busy');
    const p = document.createElement('p'); p.setAttribute('role', 'alert');
    p.textContent = text(error.message, 'Fabrik tersimpan tidak dapat disegerakkan. Pilihan anda dikekalkan. Cuba lagi.'); root.append(p);
    if (retry) { const button = document.createElement('button'); button.type = 'button'; button.textContent = text('Retry', 'Cuba lagi'); button.addEventListener('click', retry); root.append(button); }
  }
  function render() {
    const state = client.snapshot(), busy = state.loading || state.pending;
    for (const node of document.querySelectorAll('[data-fp-wishlist-count]')) {
      node.textContent = state.error ? '!' : state.count === null ? '…' : String(state.count);
      node.setAttribute('aria-label', state.error ? text('Saved fabrics need attention', 'Fabrik tersimpan memerlukan perhatian') : text('Saved fabrics', 'Fabrik tersimpan'));
      node.setAttribute('aria-busy', String(busy));
    }
    for (const button of document.querySelectorAll('[data-fp-save]')) {
      button.disabled = busy || !!state.error;
      button.setAttribute('aria-pressed', String(client.isSaved(button.dataset.productId, button.dataset.url)));
      button.setAttribute('aria-busy', String(busy));
    }
    for (const button of document.querySelectorAll('[data-fp-remove-saved]')) button.disabled = busy;
    if (state.error && dialog()?.open) feedback(state.error, refresh);
  }
  async function loadPage(cursor) {
    const root = list(); if (!root) return;
    pageRequest?.abort(); const controller = new AbortController(); pageRequest = controller;
    if (!cursor) root.replaceChildren();
    root.setAttribute('aria-busy', 'true');
    const loading = document.createElement('p'); loading.setAttribute('role', 'status'); loading.textContent = text('Loading saved fabrics…', 'Memuatkan fabrik tersimpan…'); root.append(loading);
    try {
      const page = await client.list(cursor, controller.signal);
      if (controller.signal.aborted) return;
      let items = page.nodes.map(x => ({...x, image: x.image?.url || ''}));
      if (items.length && document.querySelector('[data-dss-market-context]')?.dataset.enabled === 'true') {
        const references = items.filter(x => x.available !== false).map(x => {
          const url = new URL(x.url, location.origin);
          if (url.origin !== location.origin || !/^\/products\/[a-z0-9-]+$/.test(url.pathname)) throw new Error('Invalid saved fabric reference');
          return {...x, url: url.pathname};
        });
        const resolved = await window.DSSMarketPresentation.resolve(references, controller.signal);
        const byPath = new Map(resolved.map(x => [x.url, x]));
        items = items.map(x => {
          if (x.available === false) return x;
          const value = byPath.get(new URL(x.url, location.origin).pathname);
          if (!value) throw new Error('Missing saved fabric content');
          return {...value, id: x.id};
        });
      }
      if (controller.signal.aborted) return;
      loading.remove(); root.removeAttribute('aria-busy');
      if (!items.length && !cursor) { const p = document.createElement('p'); p.textContent = text('Save fabrics with the heart on a product card. Your selection will appear here.', 'Simpan fabrik menggunakan ikon hati pada kad produk. Pilihan anda akan dipaparkan di sini.'); root.append(p); }
      for (const item of items) {
        const row = document.createElement('div'); row.className = 'fp-saved-item';
        const image = document.createElement('img'); image.alt = item.title; image.loading = 'lazy'; if (/^(https:)?\/\//.test(item.image)) image.src = item.image;
        const link = document.createElement('a'); link.href = localUrl(item.url); link.textContent = item.title;
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.dataset.fpRemoveSaved = item.url;
        if (item.id) remove.dataset.productId = atob(item.id.replace(/-/g, '+').replace(/_/g, '/'));
        remove.setAttribute('aria-label', text('Remove ', 'Buang ') + item.title); row.append(image, link, remove); root.append(row);
      }
      if (page.nextCursor) { const more = document.createElement('button'); more.type = 'button'; more.textContent = text('Load more', 'Muatkan lagi'); more.addEventListener('click', () => {more.remove(); loadPage(page.nextCursor);}); root.append(more); }
      render();
    } catch (error) { if (!controller.signal.aborted) feedback(error, () => loadPage()); }
  }
  async function refresh() {
    try { await client.refresh(); if (dialog()?.open) await loadPage(); }
    catch (error) { if (dialog()?.open) feedback(error, refresh); }
  }
  try {
    const bridge = document.querySelector('[data-fp-member-import]');
    const params = new URLSearchParams(location.hash.slice(1));
    if (bridge && params.get('sync') === '1' && (!/^[a-f0-9-]{36}$/.test(params.get('nonce') || '') || !/^[a-f0-9]{64}$/.test(params.get('context') || ''))) throw new Error('Saved fabric sync could not be verified.');
    client = window.FivePointSaved.create({origin: new URL(config.dataset.memberOrigin).origin, storage: localStorage});
    window.FivePointSavedClient = client;
    window.FivePointSavedControls = {render};
    client.subscribe(render);
    client.ready = client.refresh(bridge && params.get('sync') === '1' ? {expectedFingerprint: params.get('context')} : {});
    client.ready.catch(() => {}); // State keeps the error visible; the bridge also awaits this exact result.
    document.addEventListener('click', async event => {
      const button = event.target.closest('button'); if (!button) return;
      if (button.matches('[data-fp-wishlist-open]')) { if (!dialog().open) dialog().showModal(); await loadPage(); }
      if (!button.matches('[data-fp-save],[data-fp-remove-saved]')) return;
      const {url, title, image, productId} = button.dataset;
      const wasGuest = client.snapshot().authenticated === false, wasSaved = client.isSaved(productId, url);
      try {
        if (button.matches('[data-fp-save]')) await client.toggle({url, title, image, productId});
        else await client.remove(productId, button.dataset.fpRemoveSaved);
        if (wasGuest) window.FivePointEvents?.emit('fp_saved_change', {action: wasSaved || button.matches('[data-fp-remove-saved]') ? 'remove' : 'add', storage: 'local', item_count: 1}, {component_id: 'local-saved'});
        if (dialog()?.open) await loadPage();
      } catch (error) { if (!dialog()?.open) dialog()?.showModal(); feedback(error, refresh); }
    });
    window.addEventListener('focus', refresh);
    window.addEventListener('storage', event => { if (event.key === 'fivepoint:saved-fabrics:v1') refresh(); });
    render();
  } catch (error) {
    feedback(error);
    for (const node of document.querySelectorAll('[data-fp-wishlist-count]')) node.textContent = '!';
    for (const button of document.querySelectorAll('[data-fp-save]')) button.disabled = true;
    document.addEventListener('click', event => { if (event.target.closest('[data-fp-wishlist-open]') && !dialog()?.open) dialog()?.showModal(); });
  }
})();
